import React, { useEffect, useState } from 'react';
import { useParams, useLocation, useNavigate } from 'react-router-dom';
import { Breadcrumb, Loader, Nav, Panel, Stack } from 'rsuite';
import ActivityInfoForm from './activity-info-form';
import { BaseErrorModel, BaseResponseModel, PageState } from '@/models/core.model';
import { AxiosError } from 'axios';
import { toastErrorMessage } from '@/utils/toasterMessage';
import { ActivityInfo } from '@/models/activity-info.model';
import { getActivityInfo } from '@/services/activity-info.service';
import ActivityActions from './activity-actions';
import PageHeader from '@/components/PageHeader';
import AdvanceShareList from '@/pages/advance-share/list/advance-share-list';

const CustomNav = ({ active, onSelect, newMode, formObject, ...props }) => {
  const nav = useNavigate();  
  return (
    <Stack justifyContent={"space-between"}>
      <Nav {...props} activeKey={active} onSelect={onSelect}>
        <Nav.Item eventKey="activity-info-form">Activity Info</Nav.Item>
        <Nav.Item eventKey="activity-info-actions" disabled={newMode}>Actions</Nav.Item>
        <Nav.Item eventKey="activity-info-advance-share-requests" disabled={newMode}>Advance Share Requests</Nav.Item>
      </Nav>
    </Stack>
  );
};

const Page = () => {

  const requestedTab = useLocation()?.state?.tab;

  const [activeTab, setActiveTab] = useState('activity-info-form');
  const [formObject, setFormObject] = useState<ActivityInfo|undefined>(undefined);
  const [loading, setLoading] = useState(false);

  const nav = useNavigate();

  const { id: idParam } = useParams();
  const id = idParam ? parseInt(idParam, 10) : undefined;
  const pageState = id ? PageState.Edit : PageState.New;


  useEffect(() => {
    if (pageState == PageState.Edit) {
      fetchData();
    } else {
      setFormObject(undefined);
    }
    setActiveTab(pre => requestedTab ?? pre);
  }, [id]);
  
  const fetchData = async () => {
    if (id) {
      setLoading(true);
      try {
        const result: BaseResponseModel<ActivityInfo> = await getActivityInfo(id);
        if (result.success) {
          setFormObject(result.result);
        }
      } catch (err) {
        const errorModel = (err as AxiosError<BaseErrorModel>).response?.data;
        toastErrorMessage(`Error in fetching Activity Info: ${errorModel?.errorMessage}`);
        nav('/activities');
      }
      finally {
        setLoading(false);
      }
    }
  };
 
  return (

    <Panel
     header = {
      <PageHeader title = "Activity Info Details">
        <Breadcrumb>
          <Breadcrumb.Item href="/">Home</Breadcrumb.Item>
          <Breadcrumb.Item href='/activities'>Activity Infos</Breadcrumb.Item>
          <Breadcrumb.Item active>Detail</Breadcrumb.Item>
        </Breadcrumb>
      </PageHeader>
    }>
        <CustomNav appearance="subtle" 
          active={activeTab} 
          onSelect={key => setActiveTab(key)} 
          newMode={pageState == PageState.New} 
          formObject={formObject}
        />
        {
          loading ? <Loader center content="loading ..." /> :
          <>
            {activeTab == 'activity-info-form' && id && <ActivityInfoForm formObject={formObject}/>}
            {activeTab == 'activity-info-actions' && id && <ActivityActions formObject={formObject}/>}
            {activeTab == 'activity-info-advance-share-requests' && <AdvanceShareList activityInfoId={formObject?.id} />}
          </>
        }        
    </Panel>
  );
};

export default Page;
